












































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcScheduleSlotsGeneratorModal from './schedule-slots-generator-modal.vue';
import {
  DayType,
  OnlineBookingSlot,
  OnlineBookingSlotGeneratorFormModel,
  OnlineBookingSlotsByWeekDay,
  SlotDuration,
} from '@bookings/interfaces/schedule';
import ScheduleService, { useScheduleService } from '@bookings/services/schedule-service';

@Component({
  name: 'bpc-schedule-online-booking-slot-grid',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcScheduleSlotsGeneratorModal,
  },
})
export default class ScheduleOnlineBookingSlotGrid extends Vue {
  // @Prop(Object) readonly slotCollection: OnlineBookingSlotsByWeekDay;
  @Prop(Object) readonly value: OnlineBookingSlotsByWeekDay;
  @Prop(String) readonly label: string;
  @Prop(Number) readonly duration: SlotDuration;
  @Prop(String) readonly dayType: DayType;

  srv: ScheduleService = null;
  showSlotGenerator = false;
  generatorFormModel: OnlineBookingSlotGeneratorFormModel = null;

  get slotCollection() {
    return this.value;
  }

  set slotCollection(value: OnlineBookingSlotsByWeekDay) {
    this.$emit('input', value);
  }

  get collapseId() {
    return `collapse-${this.dayType}-${this.duration}`;
  }

  created() {
    this.srv = useScheduleService();
  }

  mounted() {
    this.resetGeneratorFormModel();
  }

  onSlotClicked(slot: OnlineBookingSlot) {
    const startTime = slot.start_time;
    const startHour = startTime.split(':')[0];
    const startMinute = startTime.split(':')[1];
    const end = new Date();
    end.setHours(Number(startHour));
    end.setMinutes(Number(startMinute));
    end.setSeconds(0);
    end.setMilliseconds(0);
    end.setMinutes(end.getMinutes() + slot.slot_duration);

    this.generatorFormModel = {
      slot_duration: slot.slot_duration,
      start_time: slot.start_time,
      end_time: this.$bpcHelper.formatDateTime2Time(end),
      slot_price_category: slot.slot_price_category,
      day_type: slot.day_type,
      week_days_range: 'custom',
      selected_week_days: [slot.weekday],
    };

    this.showSlotGenerator = true;
  }

  onBulkAddSlots() {
    this.resetGeneratorFormModel();
    this.showSlotGenerator = true;
  }

  resetGeneratorFormModel() {
    this.generatorFormModel = {
      slot_duration: this.duration,
      start_time: '08:00',
      end_time: '20:00',
      slot_price_category: null,
      day_type: this.dayType,
      week_days_range: 'mon_sun',
      selected_week_days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    };
  }

  onRemoveSlotClicked(slot: OnlineBookingSlot, day: string) {
    this.slotCollection[day] = this.slotCollection[day].filter(s => s.id !== slot.id);
    // this.$emit('remove-slot', { slot, day });
  }

  clearSlots() {
    this.slotCollection = {
      mon: [],
      tue: [],
      wed: [],
      thu: [],
      fri: [],
      sat: [],
      sun: [],
    };
  }

  onGenerateSlots(generatorFormModel: OnlineBookingSlotGeneratorFormModel) {
    this.$emit('generate-slots', generatorFormModel);
    this.showSlotGenerator = false;
  }

  categoryColorLineStyle(slotPriceCategory) {
    return {
      backgroundColor: slotPriceCategory.color,
      width: '3px',
      opacity: 0.6,
    };
  }
}
